import { Directive, HostBinding } from '@angular/core';

@Directive({
    selector: '[appSecondaryButton]',
    standalone: false
})
export class SecondaryButtonDirective {
    @HostBinding('class') get classes(): string {
        return 'secondary-button-uniform';
    }
}
